import React, { useEffect, useState } from 'react'

interface ProgressBarProps {
  progress: number
  isInterStep?: boolean
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, isInterStep = false }) => {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => setWidth(progress), 10)
    return () => clearTimeout(timer)
  }, [progress])

  return (
    <div className="w-full mb-6">
      <div className="bg-mover-light bg-opacity-20 rounded-full h-12 overflow-hidden relative">
        <div
          className="bg-gradient-to-r from-mover-purple via-mover-cyan to-mover-magenta h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${width}%` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-20 animate-shimmer"></div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-sm font-bold text-mover-lightest drop-shadow-lg">
            {Math.round(width)}%
          </span>
        </div>
      </div>
      <p className="text-center mt-2 text-sm text-mover-light">
        {isInterStep ? 'Almost there! Please provide your details.' : (width < 100 ? 'Crawling your website now...' : 'Audit Complete')}
      </p>
    </div>
  )
}

export default ProgressBar